module.exports = __webpack_public_path__ + "assets/pdf/E06-en-arup-climate-risk.b15d4364.pdf";